import { useBooking } from '@/store/booking.store'

export default function ResolveExternalUrlNavigation(urlString: string): void {
  const url = new URL(urlString)
  url.searchParams.append('correlationId', useBooking().correlationId as string)
  window.location.href = url.toString()
}
